import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const Auth = () => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const hasFetched = useRef(false);
    let executionCount = 0;

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        executionCount++; 
        const handleAuthResponse = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const code = params.get('code');
                console.log("Authorization Codez:", code);
                if (code) {
                    const backendResponse = await fetch('https://8f65-38-25-8-218.ngrok-free.app/api/auth/microsoft-login', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'ngrok-skip-browser-warning': '1'
                        },
                        body: JSON.stringify({ code }),
                    });

                    if (!backendResponse.ok) {
                        navigate('/');
                        return;
                    }

                    const backendData = await backendResponse.json();

                    if (!backendData.token) {
                        navigate('/');
                        return;
                    }

                    localStorage.setItem('authToken', backendData.token);

                    localStorage.setItem('user', JSON.stringify(backendData.user));

                    navigate('/tablero');
                } else {
                    navigate('/');
                }
            } catch (error) {
                console.error('Error during authentication: ', error);
                navigate('/');
            } finally {
                setLoading(false);
            }
        };

        handleAuthResponse();
    }, [navigate]);

    return (
        <div>
            {loading ? (
                <div>Validando usuario...</div>
            ) : (
                <div>Redirigiendo</div>
            )}
        </div>
    );
};

export default Auth;